import {BasketBlock} from './basket/basket-block'
import {BasketLink} from './basket/basket-link'
import {cartDelivery} from './cart-delivery'

class AjaxCart {
  constructor() {
      this.init();
  }
  init() {
      console.log('[ AjaxCart ] init');
      this.addItemCart();
      this.updateCart();
      this.delItemCart();
      this.promoUpd();
      this.promoLoad();
      this.delivClickFun();
  }
  addItemCart() {
    console.log('[ AjaxCart ] A');
    $('.js-cart-add').click(function(){
      var checkter = 0;
      $('.js-check[data-method_type="product"]').each(function(){
        if ($(this).prop('checked')) {checkter = 1}
      })
      if (checkter) {
      var inf = {
        modif_id : $(this).data('modif_id'),
        num_id : $(this).data('num_id')
      }
      $.ajax({
        method: "POST",
        url:'/oa/add_item/',
        data: inf,
        dataType:'json'
      }).then((data) => {
        console.log(data);
        this.basket = new BasketBlock();
        this.basket.basketUpdate(data);
        this.basket.sumUpdate(data);
		let product = {
            id: data.item.modif_id,
            //name: item.name,
            price: data.item.price,
            brand: 'Carforma',
            //category: 'Авто',
            quantity: data.item.count,
            list: 'Результаты поиска',
            //position: item.position
        };
        window.dataLayer.push({
	        ecommerce: {
	            currencyCode: 'RUB',
	            add: {
	                products: product
	            }
	        }
        });
    })
    } else {
      let topanim = $('#select_material').offset().top;
      $("body,html").animate({scrollTop: topanim}, 800);
      if ($('#select_material').hasClass('item-selectequip--closer')) {
        $('#select_material').removeClass('item-selectequip--closer');
        $('#select_material .js-block-closer').addClass('item__block-open');
        $('#select_material .js-block-closer').siblings('.js-close-wrap').slideDown();
      }
      if ($('.select__equipment .h3.select__equipment__header').find('.js-add-text').length != 1) {
        console.log($('.select__equipment .h3.select__equipment__header').find('.js-add-text').length);
        $('.select__equipment .h3.select__equipment__header').append('<div class="js-add-text" style="color:red; font-size:14px;">Выберите товар для добавления в корзину</div>');
      }
    }
    })
  }
  updateCart() {
    console.log('[ AjaxCart ] B');
    $('.js-counter__plus').click(function(){
      var inf = {
        modif_id : $(this).data('modif_id'),
        num_id : $(this).data('num_id'),
        count : Number($(this).siblings('div').text()) + 1
      }
      $.ajax({
        method: "POST",
        url:'/oa/update_item/',
        data: inf,
        dataType:'json'
      }).then((data) => {
        console.log(data);
        this.basket = new BasketBlock();
        this.basket.basketUpdate(data);
        this.basket.sumUpdate(data);
      })
    })
    $('.js-counter__minus').click(function(){
      var inf = {
        modif_id : $(this).data('modif_id'),
        num_id : $(this).data('num_id'),
        count : Number($(this).siblings('div').text()) - 1
      }
      $.ajax({
        method: "POST",
        url:'/oa/update_item/',
        data: inf,
        dataType:'json'
      }).then((data) => {
        console.log(data);
        this.basket = new BasketBlock();
        this.basket.basketUpdate(data);
        this.basket.sumUpdate(data);
      })
    })
  }
  delItemCart() {
    console.log('[ AjaxCart ] C');
    $('.js-product-delete').click(function(){
      var delConf = confirm('Вы точно хотите удалить товар?');
      if (delConf) {
      var inf = {
        modif_id : $(this).data('modif_id'),
        num_id : $(this).data('num_id')
      }
      $.ajax({
        method: "POST",
        url:'/oa/delete_item/',
        data: inf,
        dataType:'json'
      }).then((data) => {
        console.log(data);
        if (data.count == 0) {
          location.href=location.href;
        } else {
        $(this).closest('.tabs-product').remove();
        this.basket = new BasketBlock();
        this.basket.basketUpdate(data);
        this.basket.sumUpdate(data);
      }
      })
      }
    })
  }
  promoUpd() {
    $('.js-promo__btn').click(function(){
 	  $(window).trigger('goal.main', $(this).data());
      $('.js-promo__input').removeClass('promo__input--right');
      $('.js-promo__input').removeClass('promo__input--wrong');
      var newval = $('.js-promo__input').val();
      $(this).removeClass('promo__btn--right');
      $(this).removeClass('promo__btn--wrong');
      if (!$(this).hasClass('js-delete-promo')) {
      var input = new FormData(document.getElementById('promo__form'));
      if (newval) {
        $.ajax({
          method: "POST",
          url:'/oa/check_promo/',
          data: input,
          processData: false,
          contentType: false,
          dataType:'json'
        }).then((data) => {
          console.log(data);
          if (data.item.error != 1) {
            $('.js-promo__input').addClass('promo__input--right');
            $('.js-promo__input').prop('disabled',true);
            $(this).addClass('promo__btn--right js-delete-promo');
            $(this).text('Удалить промокод');
            $('#promo-error').text('');
            this.basket = new BasketBlock();
            this.basket.sumUpdate(data);
          } else {
            $('.js-promo__input').addClass('promo__input--wrong');
            $('#promo-error').text(data.item.text);
            $(this).addClass('promo__btn--wrong');
            $('.js-promo__input').prop('disabled',false);
          }
        })
        return false;
      } else {
        $('.js-promo__input').addClass('promo__input--wrong');
        $('#promo-error').text('Промокод не введен');
      }
        } else {
          $.ajax({
            method: "POST",
            url:'/oa/delete_promo/',
          }).then((data) => {
            this.basket = new BasketBlock();
            this.basket.sumUpdate(data);
          });
          $('.js-promo__input').prop('disabled',false);
          $('.js-promo__input').val('');
          $(this).text('Подтвердить');
          $(this).removeClass('js-delete-promo');
        }
      })
      $('form#promo__form').on('submit',function(e){
        e.preventDefault();
        $('.js-promo__input').removeClass('promo__input--right');
        $('.js-promo__input').removeClass('promo__input--wrong');
        var newval = $('.js-promo__input').val();
        $('.js-promo__btn').removeClass('promo__btn--right');
        $('.js-promo__btn').removeClass('promo__btn--wrong');
        if (!$('.js-promo__btn').hasClass('js-delete-promo')) {
        var input = new FormData(document.getElementById('promo__form'));
        if (newval) {
          $.ajax({
            method: "POST",
            url:'/oa/check_promo/',
            data: input,
            processData: false,
            contentType: false,
            dataType:'json'
          }).then((data) => {
            console.log(data);
            if (data.item.error != 1) {
              $('.js-promo__input').addClass('promo__input--right');
              $('.js-promo__input').prop('disabled',true);
              $('.js-promo__btn').addClass('promo__btn--right js-delete-promo');
              $('.js-promo__btn').text('Удалить промокод');
              $('#promo-error').text('');
              this.basket = new BasketBlock();
              this.basket.sumUpdate(data);
            } else {
              $('.js-promo__input').addClass('promo__input--wrong');
              $('#promo-error').text(data.item.text);
              $('.js-promo__btn').addClass('promo__btn--wrong');
              $('.js-promo__input').prop('disabled',false);
            }
          })
          return false;
        } else {
          $('.js-promo__input').addClass('promo__input--wrong');
          $('#promo-error').text('Промокод не введен');
        }
          } else {
            $.ajax({
              method: "POST",
              url:'/oa/delete_promo/',
            }).then((data) => {
              this.basket = new BasketBlock();
              this.basket.sumUpdate(data);
            });
            $('.js-promo__input').prop('disabled',false);
            $('.js-promo__input').val('');
            $('.js-promo__btn').text('Подтвердить');
            $('.js-promo__btn').removeClass('js-delete-promo');
          }
      })
  }
  promoLoad() {
    $(document).ready(function(){
      if ($('.js-promo__input').val()) {
        var input = new FormData(document.getElementById('promo__form'));
        $.ajax({
          method: "POST",
          url:'/oa/check_promo/',
          data: input,
          processData: false,
          contentType: false,
          dataType:'json'
        }).then((data) => {
          console.log(data);
            $('.js-promo__input').addClass('promo__input--right');
            $('.js-promo__input').prop('disabled',true);
            $('.js-promo__btn').addClass('promo__btn--right js-delete-promo');
            $('.js-promo__btn').text('Удалить промокод');
            $('#promo-error').text('');
            this.basket = new BasketBlock();
            this.basket.sumUpdate(data);
          });
        }
    })
  }
  delivClickFun() {
    $('.js-checkout__btn').click(function(){
      this.link = new BasketLink;
    });
  }
}

export {
  AjaxCart
}
